import { render, staticRenderFns } from "./FaqSection.vue?vue&type=template&id=3a7d1cc8&"
import script from "./FaqSection.vue?vue&type=script&lang=ts&"
export * from "./FaqSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FaqsCollapsibleContainer: require('/opt/build/repo/apps/shop/components/storyblok/FaqsCollapsibleContainer/FaqsCollapsibleContainer.vue').default})
